import React, { Component } from 'react';
import { Link } from 'react-router-dom';

class ThankYouPage extends Component {

    componentDidMount() {
        window.scrollTo(0, 0)
    }

    render() {
        return (
            <section className="placed-order-wrapper">
                <h2>THANK YOU VERY MUCH FOR PLACEING YOUR ORDER!</h2>

                <h3> you will get your order in the next couple of weeks, meanwhile remmeber this is just a demo site!</h3>

                    <div className="checkout-btn-wrapper">
                    <Link className="checkout-btn" to="/">CONTINUE SHOPPING</Link>
                </div>

            </section>
        );
    }
}



export default ThankYouPage